// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Service.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { DiagramShape } from '../../../../../com/MetaPattern/MDA/Designer/Shape/DiagramShape';
import { get, post } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Request';
class SaveDiagramDTO {
  diagramShape: DiagramShape;

  public toJson(): any {
    const json: any = {};
    if (this.diagramShape.toJson) {
      json.DiagramShape = this.diagramShape.toJson();
    } else {
      json.DiagramShape = this.diagramShape;
    }
    return json;
  }
}
/**
 * 图形服务 服务类
 * 图形服务
 */
export class ShapeService {
  static async GetFullDiagramAsync(componentId: string): Promise<DiagramShape | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mdapp/service/shapeservice/getfulldiagram', { componentId: componentId })
        .then((response: any) => {
          let result: DiagramShape | null = null;
          if (response) {
            result = DiagramShape.Create(response);
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async InitDataAsync(): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mdapp/service/shapeservice/initdata')
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async SaveDiagramAsync(diagramShape: DiagramShape): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new SaveDiagramDTO();
      dto.diagramShape = diagramShape;
      post('metapattern-ide-mdapp/service/shapeservice/savediagram', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }
}
